(function () {
  const selectors = {
    badge: '[data-header-cart-count]',
    atcCartButton: '[data-atc-banner-cart-button]',
    quantityButton: '[data-quantity-plus], [data-quantity-minus]',
    quantityInput: '[data-quantity-input]',
    removeLink: '[data-cartitem-remove]'
  };

  let syncTimer = null;

  function applyLineCount(count) {
    const normalized = Number.isFinite(count) && count > 0 ? String(count) : '';

    document.querySelectorAll(selectors.badge).forEach((badge) => {
      badge.setAttribute('data-header-cart-count', normalized);
      badge.classList.toggle('visible', Boolean(normalized));
    });

    document.querySelectorAll(selectors.atcCartButton).forEach((button) => {
      const countTarget = button.querySelector('span');
      if (countTarget) {
        countTarget.textContent = normalized;
      }
    });
  }

  function syncLineCount() {
    fetch(window.Theme.routes.cart_url + '.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .then((cart) => {
        const lineCount = Array.isArray(cart.items) ? cart.items.length : 0;
        applyLineCount(lineCount);
      })
      .catch(() => {});
  }

  function queueSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncLineCount, delay);
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncLineCount();

    document.addEventListener('click', function (event) {
      if (event.target.closest(selectors.quantityButton) || event.target.closest(selectors.removeLink)) {
        queueSync(900);
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches(selectors.quantityInput)) {
        queueSync(900);
      }
    });

    window.addEventListener('cartcount:update', function (event) {
      const detail = event.detail || {};
      const lineCount = Array.isArray(detail.items) ? detail.items.length : null;

      if (lineCount === null) {
        queueSync(100);
        return;
      }

      applyLineCount(lineCount);
    });
  });
})();
